// export const NEWS_HOT_TYPE = {
//     true: '是',
//     false: '否'
// };

export const NEWS_HOT_TYPE = [
    {value: true, label: '是'},
    {value: false, label: '否'}
];
